module.exports = __webpack_public_path__ + "static/media/report-2.ecba1cb4.svg";